import { ResponseGetCategories_categoryId_ } from "@CommonApi/categories/_categoryId_";
import { ResponseGetMerchflows_merchflowId_Details } from "@CommonApi/merchflows/_merchflowId_/details";
import { ResponseGetStores_storeId_ } from "@CommonApi/stores/_storeId_";
import { Project } from "src/omni-common/projects";
import { omniAtom } from "src/utils/atoms";

const prefix = "merchflowHeader";

export const merchflows_merchflowId_DetailsAtom = omniAtom({
  prefix,
  key: "details",
  value: undefined as undefined | null | ResponseGetMerchflows_merchflowId_Details,
});

export const merchflowHeaderFroggerVersionAtom = omniAtom({
  prefix,
  key: "froggerVersion",
  value: "",
});

export const merchflowHeaderProjectAtom = omniAtom({
  prefix,
  key: "project",
  value: undefined as Project | null | undefined,
});

export const merchflowHeaderCategoryAtom = omniAtom({
  prefix,
  key: "category",
  value: undefined as ResponseGetCategories_categoryId_ | null | undefined,
});

export const merchflowHeaderStoreAtom = omniAtom({
  prefix,
  key: "store",
  value: undefined as ResponseGetStores_storeId_ | null | undefined,
});
